﻿import 'ol/ol.css';
import Draw from 'ol/interaction/Draw';
import {Draw, Modify, Select, Snap} from 'ol/interaction';
import Map from 'ol/Map';
import Overlay from 'ol/Overlay';
import TileWMS from 'ol/source/TileWMS';
import View from 'ol/View';
import BingMaps from 'ol/source/BingMaps';
import TileLayer from 'ol/layer/Tile';
import {useGeographic} from 'ol/proj';
import {Point} from 'ol/geom';
import {Circle, Fill, Style, Text,Icon} from 'ol/style';
import {Feature, Map, Overlay, View} from 'ol/index';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {LineString, Polygon} from 'ol/geom';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {getArea, getLength} from 'ol/sphere';
import {unByKey} from 'ol/Observable';
import {ScaleLine, defaults as defaultControls} from 'ol/control';
import {defaults as defaultControls} from 'ol/control';
import WKT from 'ol/format/WKT';
import MousePosition from 'ol/control/MousePosition';
import {createStringXY, format} from 'ol/coordinate';
import {fromLonLat} from 'ol/proj';
import Graticule from 'ol/layer/Graticule';
import Stroke from 'ol/style/Stroke';
import {applyTransform} from 'ol/extent';
import {get as getProjection, getTransform} from 'ol/proj';
import TileDebug from 'ol/source/TileDebug';
import OSM from 'ol/source/OSM';
import {Image as ImageLayer, Tile as TileLayer} from 'ol/layer';
import {Raster as RasterSource, XYZ} from 'ol/source';
import {bbox as bboxStrategy} from 'ol/loadingstrategy';
import GeoJSON from 'ol/format/GeoJSON';
import MultiPoint from 'ol/geom/MultiPoint';
import {
    Pointer as PointerInteraction,
    DragAndDrop,
    defaults as defaultInteractions,
} from 'ol/interaction';
import {GPX, GeoJSON, IGC, KML, TopoJSON} from 'ol/format';
import {ImageArcGISRest, OSM} from 'ol/source';
import {Group as LayerGroup, Tile as TileLayer} from 'ol/layer';
import {OSM, TileArcGISRest} from 'ol/source';
import {transform} from 'ol/proj';
import {getCenter} from 'ol/extent';
import {Draw, Modify, Select, Snap} from 'ol/interaction';
import ZoomSlider from 'ol/control/ZoomSlider';
import {Control, defaults as defaultControls} from 'ol/control';
import ContextMenu from 'ol-contextmenu';
import {register} from 'ol/proj/proj4';
import proj4 from 'proj4';
import GML3 from 'ol/format/GML3';
import {bbox as bboxStrategy} from 'ol/loadingstrategy';
proj4.defs( 'EPSG:32638',
  'PROJCS["Transverse_Mercator",GEOGCS["WGS_1984",DATUM["D_WGS_1984",' +
    'SPHEROID["WGS_1984",6378137.000,298.25722210]],PRIMEM["Greenwich",0],' +
    'UNIT["Degree",0.017453292519943295]],PROJECTION["Transverse_Mercator"],' +
    'PARAMETER["false_easting",500000],' +
    'PARAMETER["false_northing",0],' +
    'PARAMETER["scale_factor",0.999966666667],' +
    'PARAMETER["central_meridian",45],' +
    'PARAMETER["latitude_of_origin",0],' +
    'UNIT["Meter",1]]' );

proj4.defs( 'EPSG:32639',
'+proj=utm +zone=39 +ellps=WGS84 +datum=WGS84 +units=m +no_defs' );

proj4.defs( 'EPSG:32640',
'+proj=utm +zone=40 +ellps=WGS84 +datum=WGS84 +units=m +no_defs' );

proj4.defs( 'EPSG:32641',
'+proj=utm +zone=41 +ellps=WGS84 +datum=WGS84 +units=m +no_defs' );

proj4.defs( 'EPSG:4326',
    '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees' );
	
register(proj4);
const proj32638 = getProjection('EPSG:32638');
const proj32639 = getProjection('EPSG:32639');
const proj32640 = getProjection('EPSG:32640');
const proj32641 = getProjection('EPSG:32641');
const proj4326 = getProjection('EPSG:4326');

 

var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

var drawFeatureObjects=[];

class Drag extends PointerInteraction {
    constructor() {
        super({
            handleDownEvent: handleDownEvent,
            handleDragEvent: handleDragEvent,
            handleMoveEvent: handleMoveEvent,
            handleUpEvent: handleUpEvent,
        });

        /**
         * @type {import("../src/ol/coordinate.js").Coordinate}
         * @private
         */
        this.coordinate_ = null;

        /**
         * @type {string|undefined}
         * @private
         */
        this.cursor_ = 'pointer';

        /**
         * @type {Feature}
         * @private
         */
        this.feature_ = null;

        /**
         * @type {string|undefined}
         * @private
         */
        this.previousCursor_ = undefined;
    }
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Map browser event.
 * @return {boolean} `true` to start the drag sequence.
 */
function handleDownEvent(evt) {
    const map = evt.map;

    const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        if(feature.get('group')==='drawing') {
            return feature;
        }else{
            return false;
        }
    });

    if (feature) {
        this.coordinate_ = evt.coordinate;
        this.feature_ = feature;
    }

    return !!feature;
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Map browser event.
 */
function handleDragEvent(evt) {
    const deltaX = evt.coordinate[0] - this.coordinate_[0];
    const deltaY = evt.coordinate[1] - this.coordinate_[1];

    const geometry = this.feature_.getGeometry();
    geometry.translate(deltaX, deltaY);

    this.coordinate_[0] = evt.coordinate[0];
    this.coordinate_[1] = evt.coordinate[1];
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Event.
 */
function handleMoveEvent(evt) {
    if (this.cursor_) {
        const map = evt.map;
        const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
            if(feature.get('group')==='drawing') {
                return feature;
            }else{
                return false;
            }
        });
        const element = evt.map.getTargetElement();
        if (feature) {
            if (element.style.cursor != this.cursor_) {
                this.previousCursor_ = element.style.cursor;
                element.style.cursor = this.cursor_;
            }
        } else if (this.previousCursor_ !== undefined) {
            element.style.cursor = this.previousCursor_;
            this.previousCursor_ = undefined;
        }
    }
}

/**
 * @return {boolean} `false` to stop the drag sequence.
 */
function handleUpEvent() {
    this.coordinate_ = null;
    this.feature_ = null;
    return false;
}


// شروع کد wms

const shahrestanwmsSource = new TileWMS({
    url: 'https://gs.insdi.ir/geoserver/wms',
    params: {'LAYERS': 'LIS:shahrestan', 'TILED': true},
    serverType: 'geoserver',
    crossOrigin: 'anonymous',
});

const shahrestanwmsLayer = new TileLayer({
    source: shahrestanwmsSource,
});


//پایان کد wms


//شروع کد چرخش صفحه
class RotateNorthControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
        const options = opt_options || {};

        const button = document.createElement('button');
        button.innerHTML = 'N';

        const element = document.createElement('div');
        element.className = 'rotate-north ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target,
        });

        button.addEventListener('click', this.handleRotateNorth.bind(this), false);
    }

    handleRotateNorth() {
        this.getMap().getView().setRotation(0);
    }
}

//پایان کد چرخش صفحه

var currentAction = 'none';
$(document).on('change', '.mapAction', function (e) {
    let action = $(this).data('action');
    console.log(action);
    let value = $(this).val();
    console.log(value);
    if (value != 'none') {
        $('.mapAction').each(function (i, el) {
            if ($(el).data('action') != action) {
                $(el).val('none').trigger('change');
            }
        });
        currentAction = action + '_' + value;
        console.log(currentAction);
    } else {
        currentAction = 'none';
        return;
    }
    if (action == 'draw') {
        console.log('ExampleDraw');
        ExampleDraw.setActive(true);
    }
});

let DrawSource=new VectorSource();
// ایجاد لایه های پیش فرش
const Drawvector = new VectorLayer({
    name: "Drawvector",
    source: DrawSource,
    style: new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new Stroke({
            color: '#ffcc33',
            width: 2,
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: '#ffcc33',
            }),
        }),
    }),
}); // لایه برای ترسیم

//شروع کد بینگ
const Bingstyles = [
    //'RoadOnDemand',
    'Aerial',
    'AerialWithLabelsOnDemand',
    'CanvasDark',
];

var Binglayers = [];
let i, ii;
for (i = 0, ii = Bingstyles.length; i < ii; ++i) {
    let ml = new TileLayer({
        visible: false,
        preload: Infinity,
        source: new BingMaps({
            key: 'AmOlkYNhMJ89LbETqcA5o2hoNWSV4UKL1HpE8TXQZI6S3gjBWnaqpiqVHX8GA1zq',
            imagerySet: Bingstyles[i],
            // use maxZoom 19 to see stretched tiles instead of the BingMaps
            // "no photos at this zoom level" tiles
            // maxZoom: 19
        }),
    });
    ml.set('uname', 'BingLayer' + Bingstyles[i]);
    Binglayers.push(ml);
}
//پایان کد بینگ

const imageExtent = [0, 0, 700000, 1300000];
const raster = new TileLayer({
    source: new OSM(),
    visible: false,
}); // لایه OSM

var my_token = 'Ggu38WQ5Z_l2HtIWc8so-_55d4GiqQZnMcVHYCGQIeHeEnQaXa-EyRdW-Ma_DRgzb3bZebLZtZhCGnPPrpFOsg..';
var my_token_local = 'Ggu38WQ5Z_l2HtIWc8so-9nbgH27SNWRwKUAHq4KS1lYm4XWn3tJq9_B5KCxlgUDi1rLQpuzTkx-7pJPEB64oA..';
const AGISurl =
    'https://iraniansdi.ir/iraniansdiGIS/rest/services/' +
    'admiralty_trans91/MapServer';


// Create functions to extract KML and icons from KMZ array buffer,
// which must be done synchronously.

const zip = new JSZip();

function getKMLData(buffer) {
    let kmlData;
    zip.load(buffer);
    const kmlFile = zip.file(/.kml$/i)[0];
    if (kmlFile) {
        kmlData = kmlFile.asText();
    }
    return kmlData;
}

function getKMLImage(href) {
    let url = href;
    let path = window.location.href;
    path = path.slice(0, path.lastIndexOf('/') + 1);
    if (href.indexOf(path) === 0) {
        const regexp = new RegExp(href.replace(path, '') + '$', 'i');
        const kmlFile = zip.file(regexp)[0];
        if (kmlFile) {
            url = URL.createObjectURL(new Blob([kmlFile.asArrayBuffer()]));
        }
    }


    return url;
}

// Define a KMZ format class by subclassing ol/format/KML

class KMZ extends KML {
    constructor(opt_options) {
        const options = opt_options || {};
        options.iconUrlFunction = getKMLImage;
        super(options);
    }

    getType() {
        return 'arraybuffer';
    }

    readFeature(source, options) {
        const kmlData = getKMLData(source);
        return super.readFeature(kmlData, options);
    }

    readFeatures(source, options) {
        const kmlData = getKMLData(source);
        return super.readFeatures(kmlData, options);
    }
}

// Set up map with Drag and Drop interaction

const dragAndDropInteraction = new DragAndDrop({
    formatConstructors: [KMZ, GPX, GeoJSON, IGC, KML, TopoJSON],
});

// End Define a KMZ format class by subclassing ol/format/KML


//wfs

const vectorSource = new VectorSource({
    format: new GeoJSON(),

    url: function (extent) {

        return (
            'https://gs.insdi.ir/geoserver/LIS/ows?service=WFS&' +
            'version=2.0.0&request=GetFeature&typename=LIS%3Apolygon_test_geo&' +
            'outputFormat=application/json&s' +
            'bbox=' +
            extent.join(',') +
            ',EPSG:4326'
        );

    },

    strategy: bboxStrategy,
});


const vectorWaterSource = new VectorSource({
  format: new GeoJSON(),
  url: function (extent) {
    return (
      'https://gs.insdi.ir/geoserver/LIS/ows?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=LIS%3Aline_water_transfer&' +
      'outputFormat=application/json&srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});



const styles_vector_water = [
    // linestring
    new Style({
        stroke: new Stroke({
            color: '#190efb',
            width: 2,
        }),
    }),
];


const vector_water = new VectorLayer({
    source: vectorWaterSource,
    style: styles_vector_water,

});


const styles = [
    /* We are using two different styles for the polygons:
     *  - The first style is for the polygons themselves.
     *  - The second style is to draw the vertices of the polygons.
     *    In a custom `geometry` function the vertices of a polygon are
     *    returned as `MultiPoint` geometry, which will be used to render
     *    the style.
     */
    new Style({
        stroke: new Stroke({
            color: 'red',
            width: 3,
        }),
        fill: new Fill({
            color: 'rgba(66, 123, 255, 0.1)',
        }),
    }),
    new Style({
        image: new CircleStyle({
            radius: 5,
            fill: new Fill({
                color: 'orange',
            }),
        }),
        geometry: function (feature) {
            // return the coordinates of the first ring of the polygon
            const coordinates = feature.getGeometry().getCoordinates()[0];
            return new MultiPoint(coordinates);
        },
    }),
];

const vector_LIS = new VectorLayer({
    source: vectorSource,
    style: styles,
});

//wfs


//مدلسازی ارتفاع

function flood(pixels, data) {
    const pixel = pixels[0];
    if (pixel[3]) {
        const height =
            -10000 + (pixel[0] * 256 * 256 + pixel[1] * 256 + pixel[2]) * 0.1;
        if (height <= data.level) {
            pixel[0] = 134;
            pixel[1] = 203;
            pixel[2] = 249;
            pixel[3] = 255;
        } else {
            pixel[3] = 0;
        }
    }
    return pixel;
}

//const key = 'Get your own API key at https://www.maptiler.com/cloud/';
const key = 'OFmawg5T1VtNgoe6mVca';
const attributions =
    '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> ' +
    '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>';

const elevation = new TileLayer({
    source: new XYZ({
        url:
            'https://api.maptiler.com/tiles/terrain-rgb/{z}/{x}/{y}.png?key=' + key,
        maxZoom: 10,
        crossOrigin: '',
    }),
});
elevation.on('prerender', function (evt) {
    evt.context.imageSmoothingEnabled = false;
    evt.context.msImageSmoothingEnabled = false;
});

const raster_z = new RasterSource({
    sources: [elevation],
    operation: flood,
});
//پایان مدلسازی ارتفاع


// شروع کد تعریف استایل ابزار اندازه گیری طول و مساحت

const source = new VectorSource();

const vector = new VectorLayer({
    source: source,
    style: new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new Stroke({
            color: '#ffcc33',
            width: 2,
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: '#ffcc33',
            }),
        }),
    }),
});
// پایان کد تعریف استایل ابزار اندازه گیری طول و مساحت


// شروع بخش اول ابزار اندازه گیری طول و مساحت

/**
 * Currently drawn feature.
 * @type {import("../src/ol/Feature.js").default}
 */
let sketch;

/**
 * The help tooltip element.
 * @type {HTMLElement}
 */
let helpTooltipElement;

/**
 * Overlay to show the help messages.
 * @type {Overlay}
 */
let helpTooltip;

/**
 * The measure tooltip element.
 * @type {HTMLElement}
 */
let measureTooltipElement;

/**
 * Overlay to show the measurement.
 * @type {Overlay}
 */
let measureTooltip;

let measureTooltips=[];

/**
 * Message to show when the user is drawing a polygon.
 * @type {string}
 */
const continuePolygonMsg = 'برای ادامه ترسیم پولیگون کلیک کنید';

/**
 * Message to show when the user is drawing a line.
 * @type {string}
 */
const continueLineMsg = 'برای ادامه ترسیم خط کلیک کنید';

/**
 * Handle pointer move.
 * @param {import("../src/ol/MapBrowserEvent").default} evt The event.
 */
const pointerMoveHandler = function (evt) {
    if (typeSelect.value == 'none') {
        return;
    }
    if (evt.dragging) {
        return;
    }
    /** @type {string} */
    let helpMsg = 'برای شروع اندازه گیری کلیک کنید';

    if (sketch) {
        const geom = sketch.getGeometry();
        if (geom instanceof Polygon) {
            helpMsg = continuePolygonMsg;
        } else if (geom instanceof LineString) {
            helpMsg = continueLineMsg;
        }
    }

    helpTooltipElement.innerHTML = helpMsg;
    helpTooltip.setPosition(evt.coordinate);

    helpTooltipElement.classList.remove('hidden');
};


// پایان بخش اول کد اندازه گیری طول و مساحت


const point = new Point(5517375, 4019392);


// نمایش شبکه جغرافیایی
const graticule = new Graticule({
    // the style to use for the lines, optional.
    strokeStyle: new Stroke({
        color: 'rgba(255,120,0,0.9)',
        width: 2,
        lineDash: [0.5, 4],
    }),
    showLabels: true,
    visible: false,
    wrapX: false,
});
// پایان کد نمایش شبکه جفرافیایی

//بخش اول کد نمایش مختصات موس
const mousePositionControl = new MousePosition({
    coordinateFormat: createStringXY(4),
    projection: 'EPSG:3857',
    // comment the following two lines to have the mouse position
    // be placed within the map.
    className: 'custom-mouse-position',
    /*   target: document.getElementById('mouse-position')   */
});


// بخش دوم کد ارتفاع
const control = document.getElementById('level');
const output = document.getElementById('output');
const listener = function () {
    output.innerText = control.value;
    raster_z.changed();
};
control.addEventListener('input', listener);
control.addEventListener('change', listener);
output.innerText = control.value;

raster_z.on('beforeoperations', function (event) {
    event.data.level = control.value;
});

const locations = document.getElementsByClassName('location');
for (let i = 0, ii = locations.length; i < ii; ++i) {
    locations[i].addEventListener('click', relocate);
}

function relocate(event) {
    const data = event.target.dataset;
    const view = map.getView();
    view.setCenter(fromLonLat(data.center.split(',').map(Number)));
    view.setZoom(Number(data.zoom));
}

// پایان بخش دوم ارتفاع


let raster_z_l = new ImageLayer({
    opacity: 0.6,
    source: raster_z,
});
let AdmiraltyTileLayer = new TileLayer({
    source: new TileArcGISRest({
        ratio: 1,
        params: {TOKEN: my_token},
        url: AGISurl,
    }),
});


var vectorLayerMenu = new VectorLayer({ source: new VectorSource() });

var mainLayers = [
    raster,
    raster_z_l,
    AdmiraltyTileLayer,
    shahrestanwmsLayer,
    graticule,
    vector_LIS,
    vector_water,
    vector,
    Drawvector,
    vectorLayerMenu,

];

raster.set('uname', 'raster');
raster_z_l.set('uname', 'raster_z_l');
AdmiraltyTileLayer.set('uname', 'AdmiraltyTileLayer');
shahrestanwmsLayer.set('uname', 'shahrestanwmsLayer');
graticule.set('uname', 'graticule');
vector_LIS.set('uname', 'vector_LIS');
vector_water.set('uname', 'vector_water');
vector.set('uname', 'vector');
Drawvector.set('uname', 'Drawvector');
vectorLayerMenu.set('uname', 'vectorLayerMenu');

mainLayers = Binglayers.concat(mainLayers);

let layerProps = {
    default: {
        title: '1',
        visible: false,
        opacity: 100,
    },
    vectorLayerMenu: {
        title: 'لایه وکتوری کاربر',
        visible: 1,
        opacity: 100,
    },

    raster: {
        title: 'نقشه پس زمینه OSM',
        visible: false,
        opacity: 100,
    },
    raster_z_l: {
        title: 'مدیریت تراز آب',
        visible: true,
        opacity: 100,
    },
    AdmiraltyTileLayer: {
        title: 'نقشه دریایی',
        visible: false,
        opacity: 100,
    },
    shahrestanwmsLayer: {
        title: 'شهرستان ها',
        visible: false,
        opacity: 50,
    },
    graticule: {
        title: 'شبکه جغرافیایی',
        visible: false,
        opacity: 100,
    },
    vector_LIS: {
        title: 'پولیگون LIS',
        visible: false,
        opacity: 100,
    },
    vector_water: {
        title: 'مسیر عبور آب(خط)',
        visible: true,
        opacity: 100,
    },
    vector: {
        title: 'خط و پولیگون اندازه گیری شده',
        visible: true,
        opacity: 100,
    },
    Drawvector: {
        title: 'خط و پولیگون ترسیم شده کاربر',
        visible: true,
        opacity: 100,
    },
    BingLayerAerial: {
        title: 'ماهواره ای',
        visible: true,
        opacity: 100,
    },
    BingLayerAerialWithLabelsOnDemand: {
        title: 'ماهواره ای و اسامی',
        visible: false,
        opacity: 100,
    },
    BingLayerCanvasDark: {
        title: 'جاده های شب',
        visible: false,
        opacity: 100,
    },

};
let html = '';
for (let i = 0, ii = mainLayers.length; i < ii; ++i) {
    let umame = mainLayers[i].get('uname');
    let htmlcheked = 0;
    let htmltitle = '';
    let htmlopacity = 0;
    if (umame in layerProps) {
        mainLayers[i].setVisible(layerProps[umame].visible);
        mainLayers[i].setOpacity(parseFloat(layerProps[umame].opacity));
        if (layerProps[umame].visible) {
            htmlcheked = 1;
        }
        htmltitle = layerProps[umame].title;
        htmlopacity = parseFloat(layerProps[umame].opacity);
    } else {
        mainLayers[i].setVisible(layerProps['default'].visible);
        mainLayers[i].setOpacity(parseFloat(layerProps['default'].opacity));
        htmltitle = umame;
        htmlopacity = parseFloat(layerProps['default'].opacity);
    }
    html += '<li><span>' + htmltitle + '</span>\n' +
        '          <fieldset id="layer' + umame + '">\n' +
        '            <label class="checkbox" for="visible' + umame + '">\n' +
        'نمایش' +
        '<input id="visible' + umame + '" class="visible" type="checkbox"';
    if (htmlcheked) {
        html += ' checked';
    }
    html += '/></label>\n' +
        '            <label>\n' +
        'ترانسپرنسی' +
        '<input class="opacity" value="' + htmlopacity + '" type="range" min="0" max="1" step="0.01"/></label>\n' +
        '          </fieldset>\n' +
        '        </li>'
}
$('#layer ul').append(html);

var mainView= new View({
   // center: [5215478, 4256987],
	projection: 'EPSG:4326',
	
    zoom: 7,
    rotation: 0,
});
const map = new Map({

    controls: defaultControls().extend([mousePositionControl,
            new ScaleLine({
                units: 'metric',
            }),
            new ZoomSlider(), new RotateNorthControl()
        ],
    ),
    interactions: defaultInteractions().extend([dragAndDropInteraction,new Drag()]),
    layers: mainLayers,
    target: 'map',
    view: mainView,
});
//شروع کد تغییر سیستم تصویر


const viewProjSelect = document.getElementById('view-projection');


function updateViewProjection() {
  const newProj = getProjection(viewProjSelect.value);
  const newProjExtent = newProj.getExtent();
  const newView = new View({
    projection: newProj,
center: [5915478, 3856987],
    zoom: 6,
    extent: newProjExtent || undefined,
  });
  map.setView(newView);

  // Example how to prevent double occurrence of map by limiting layer extent
 
}

viewProjSelect.onchange = function () {
  updateViewProjection();
};

updateViewProjection();


//پایان کد تغییر سیستم تصویر



// شروع کد مختصات موس_جدید
var mouseLat, mouseLon;
map.on("pointermove", function (e) {
    var position = e.coordinate;
    var lonlat = transform(position, $('#view-projection').val(), 'EPSG:4326');
    displayCoordinates(lonlat);

});
// پایان کد مختصات موس_جدید

// شروع کد درگ و دراپ
dragAndDropInteraction.on('addfeatures', function (event) {
    const vectorSource = new VectorSource({
        features: event.features,
    });
    map.addLayer(
        new VectorLayer({
            source: vectorSource,
        })
    );
    map.getView().fit(vectorSource.getExtent());
});
// پایان کد درگ و دراپ


// کد تمایش مختصات مرکاتور وبی_شروع
/*
const projectionSelect = document.getElementById('projection');
projectionSelect.addEventListener('change', function (event) {
    mousePositionControl.setProjection(event.target.value);
});

const precisionInput = document.getElementById('precision');
precisionInput.addEventListener('change', function (event) {
    const format = createStringXY(event.target.valueAsNumber);
    mousePositionControl.setCoordinateFormat(format);
});
*/
// کد نمایش مختصات مرکاتور وبی_پایان


//شروع بخش دوم کد نمایش شبکه جغرافیایی
const showGraticuleCheckbox = document.getElementById('show-graticule');
showGraticuleCheckbox.onchange = function () {
    graticule.setVisible(showGraticuleCheckbox.checked);
};
// پایان بخش دوم کد نمایش شبکه جغرافیایی

// شروع بخش دوم کد اندازه گیری طول و مساحت
const typeSelect = document.getElementById('type');
map.on('pointermove', pointerMoveHandler);

map.getViewport().addEventListener('mouseout', function () {
    if (typeSelect.value == 'none') {
        return;
    }
    helpTooltipElement.classList.add('hidden');
});


let draw; // global so we can remove it later

/**
 * Format length output.
 * @param {LineString} line The line.
 * @return {string} The formatted length.
 */
const formatLength = function (line) {
    const length = getLength(line);
    let output;
    if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
    } else {
        output = Math.round(length * 100) / 100 + ' ' + 'm';
    }
    return output;
};

/**
 * Format area output.
 * @param {Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */
const formatArea = function (polygon) {
    const area = getArea(polygon);
    let output;
    if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
    } else {
        output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
    }
    return output;
};

function addInteraction() {
    if (typeSelect.value == 'none') {
        return;
    }
    const type = typeSelect.value == 'area' ? 'Polygon' : 'LineString';
    draw = new Draw({
        source: source,
        type: type,
        style: new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.2)',
            }),
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 0.5)',
                lineDash: [10, 10],
                width: 2,
            }),
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 0.7)',
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
            }),
        }),
    });


    map.addInteraction(draw);

    createMeasureTooltip();

    createHelpTooltip();

    let listener;


    draw.on('drawstart', function (evt) {
        // set sketch
        sketch = evt.feature;

        /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
        let tooltipCoord = evt.coordinate;

        listener = sketch.getGeometry().on('change', function (evt) {
            const geom = evt.target;
            let output;
            if (geom instanceof Polygon) {
                output = formatArea(geom);
                tooltipCoord = geom.getInteriorPoint().getCoordinates();
            } else if (geom instanceof LineString) {
                output = formatLength(geom);
                tooltipCoord = geom.getLastCoordinate();
            }
            measureTooltipElement.innerHTML = output;
            measureTooltip.setPosition(tooltipCoord);

        });
    });

    draw.on('drawend', function (f) {
        console.log(f);
        measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
        measureTooltip.setOffset([0, -7]);
        // unset sketch
        sketch = null;
        // unset tooltip so that a new one can be created
        measureTooltipElement = null;
        createMeasureTooltip();
        unByKey(listener);
    });
}

/**
 * Creates a new help tooltip
 */
function createHelpTooltip() {
    if (helpTooltipElement) {
        helpTooltipElement.parentNode.removeChild(helpTooltipElement);
    }
    helpTooltipElement = document.createElement('div');
    helpTooltipElement.className = 'ol-tooltip hidden';
    helpTooltip = new Overlay({
        element: helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left',
    });
    map.addOverlay(helpTooltip);
}

/**
 * Creates a new measure tooltip
 */
function createMeasureTooltip() {
    if (measureTooltipElement) {
        measureTooltipElement.parentNode.removeChild(measureTooltipElement);
    }
    measureTooltipElement = document.createElement('div');
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
    measureTooltip = new Overlay({
        element: measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center',
        stopEvent: false,
        insertFirst: false,
    });
    measureTooltips.push(measureTooltip);
    map.addOverlay(measureTooltip);
}

/**
 * Let user change the geometry type.
 */
typeSelect.onchange = function () {
    map.removeInteraction(draw);
    addInteraction();
};

addInteraction();


//پایان بخش دوم کد اندازه گیری طول و مساحت


//شروع کد تولید فایل pdf

const dims = {
    a0: [1189, 841],
    a1: [841, 594],
    a2: [594, 420],
    a3: [420, 297],
    a4: [297, 210],
    a5: [210, 148],
};

const exportButton = document.getElementById('export-pdf');

exportButton.addEventListener(
    'click',
    function () {
        exportButton.disabled = true;
        document.body.style.cursor = 'progress';

        const format = document.getElementById('format').value;
        const resolution = document.getElementById('resolution').value;
        const dim = dims[format];
        const width = Math.round((dim[0] * resolution) / 25.4);
        const height = Math.round((dim[1] * resolution) / 25.4);
        const size = map.getSize();
        const viewResolution = map.getView().getResolution();

        map.once('rendercomplete', function () {
            const mapCanvas = document.createElement('canvas');
            mapCanvas.width = width;
            mapCanvas.height = height;
            const mapContext = mapCanvas.getContext('2d');
            Array.prototype.forEach.call(
                document.querySelectorAll('.ol-layer canvas'),
                function (canvas) {
                    if (canvas.width > 0) {
                        const opacity = canvas.parentNode.style.opacity;
                        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                        const transform = canvas.style.transform;
                        // Get the transform parameters from the style's transform matrix
                        const matrix = transform
                            .match(/^matrix\(([^\(]*)\)$/)[1]
                            .split(',')
                            .map(Number);
                        // Apply the transform to the export map context
                        CanvasRenderingContext2D.prototype.setTransform.apply(
                            mapContext,
                            matrix
                        );
                        mapContext.drawImage(canvas, 0, 0);
                    }
                }
            );
            const pdf = new jspdf.jsPDF('landscape', undefined, format);
            pdf.addImage(
                mapCanvas.toDataURL('image/jpeg'),
                'JPEG',
                0,
                0,
                dim[0],
                dim[1]
            );
            pdf.save('map.pdf');

            // Reset original map size
            map.setSize(size);
            map.getView().setResolution(viewResolution);
            exportButton.disabled = false;
            document.body.style.cursor = 'auto';
        });

        // Set print size
        const printSize = [width, height];
        map.setSize(printSize);
        const scaling = Math.min(width / size[0], height / size[1]);
        map.getView().setResolution(viewResolution / scaling);
    },
    false
);

//پایان کد تولید فایل pdf 


//گروه بندی لایه ها

function bindInputs(layerid, layer) {
    const visibilityInput = $(layerid + ' input.visible');
    $(document).on('change', layerid + ' input.visible', function () {
        layer.setVisible(this.checked);
    });
    //visibilityInput.prop('checked', layer.getVisible());

    const opacityInput = $(layerid + ' input.opacity');
    $(document).on('input change', layerid + ' input.opacity', function () {
        layer.setOpacity(parseFloat(this.value));
    });
    //opacityInput.val(String(layer.getOpacity()));
}

function setup(id, group) {
    group.getLayers().forEach(function (layer, i) {
        const layerid = id + layer.get('uname');
        bindInputs(layerid, layer);
        if (layer instanceof LayerGroup) {
            setup(layerid, layer);
        }
    });
}

setup('#layer', map.getLayerGroup());

$('#layertree li > span')
    .click(function () {
        $(this).siblings('fieldset').toggle();
    })
    .siblings('fieldset')
    .hide();
//گروه بندی لایه ها


//شروع کد مدیریت لایه بینگ
/*
const select = document.getElementById('layer-select');
function onChange() {
  const style = select.value;
  for (let i = 0, ii = Binglayers.length; i < ii; ++i) {
    Binglayers[i].setVisible(Bingstyles[i] === style);
  }
}
select.addEventListener('change', onChange);
onChange();
*/
//پایان کد مدیریت لایه بینگ

//شروع کد محاسبات مختصات
function displayCoordinates(pnt) {
    var nlat = pnt[1];
    nlat = nlat.toFixed(8);
    var nlng = pnt[0];
    nlng = nlng.toFixed(8);
    var utm = ToUTM(nlat, nlng);
    utm.n = utm.n.toFixed(3);
    utm.e = utm.e.toFixed(3);

    var dms = dd2dms(nlat, nlng)

    $('#map-cor2').html('<p style="direction:ltr">' + dms.latDeg.lpad("0", 2) + '°  ' + dms.latMin.lpad("0", 2) + '\' ' + dms.latSec1.lpad("0", 2) + '.' + dms.latSec2.toTotallyFixed(3) + '" N, ' + dms.lonDeg.lpad("0", 2) + '°  ' + dms.lonMin.lpad("0", 2) + '\' ' + dms.lonSec1.lpad("0", 2) + '.' + dms.lonSec2.toTotallyFixed(3) + '" E</p>' + "عرض جغرافیایی: " + nlat + "    &nbsp;&nbsp;&nbsp;&nbsp;" + "  طول جغرافیایی: " + nlng + '<br>' + " Y/Northing(UTM): " + utm.n + "    &nbsp;&nbsp;&nbsp;" + "  X/Easting(UTM): " + utm.e + '&nbsp;&nbsp;&nbsp; زون: ' + utm.z);
}

//پایان کد محاسبات مختصات


// شروع کد ترسیم خط_نقطه_پولیگون و ویرایش آنها
let modifyDrawSelect=new Select({
    layers: function (vector_layer) {
        return vector_layer.get('name') === 'Drawvector';
    }
});
let modifyDrawSelectFeatures = modifyDrawSelect.getFeatures();
modifyDrawSelectFeatures.on('add', function(event) {
    var feature = event.element;
    $(document).on('keyup', function(event) {
        if (event.keyCode == 46) {
            modifyDrawSelectFeatures.forEach(function(selected_feature) {
                var selected_feature_id = selected_feature.ol_uid;
                modifyDrawSelectFeatures.remove(selected_feature);
                // features aus vectorlayer entfernen
                var vectorlayer_features = Drawvector.getSource().getFeatures();
                vectorlayer_features.forEach(function(source_feature) {
                    var source_feature_id = source_feature.ol_uid;
                    if (source_feature_id === selected_feature_id) {
                        Drawvector.getSource().removeFeature(source_feature);
                        var index = drawFeatures.indexOf(source_feature_id);
                        if (index !== -1) {
                            drawFeatures.splice(index, 1);
                        }
                    }
                });
            });
            $(document).off('keyup');
        }
    });
});
const ExampleModify = {
    init: function () {
        this.select = modifyDrawSelect;
        map.addInteraction(this.select);

        this.modify = new Modify({
            features: this.select.getFeatures(),
        });
        map.addInteraction(this.modify);

        this.setEvents();
    },
    setEvents: function () {
        const selectedFeatures = this.select.getFeatures();

        this.select.on('change:active', function () {
            selectedFeatures.forEach(function (each) {
                selectedFeatures.remove(each);
            });
        });
    },
    setActive: function (active) {
        this.select.setActive(active);
        this.modify.setActive(active);
        this.isActive=active;
    },
};
ExampleModify.init();

const optionsForm = document.getElementById('options-form');
let drawElements=[];
let drawFeatures=[];
var drawPoint=new Draw({
    source: Drawvector.getSource(),
    type: 'Point',
});
var drawLineString= new Draw({
    source: Drawvector.getSource(),
    type: 'LineString',
});
var drawPolygon= new Draw({
    source: Drawvector.getSource(),
    type: 'Polygon',
});
var drawCircle= new Draw({
    source: Drawvector.getSource(),
    type: 'Circle',
});
const ExampleDraw = {
    init: function () {
        map.addInteraction(this.Point);
        this.Point.setActive(false);
        map.addInteraction(this.LineString);
        this.LineString.setActive(false);
        map.addInteraction(this.Polygon);
        this.Polygon.setActive(false);
        map.addInteraction(this.Circle);
        this.Circle.setActive(false);
    },
    Point: drawPoint,
    LineString: drawLineString,
    Polygon: drawPolygon,
    Circle: drawCircle,

    getActive: function () {
        return this.activeType ? this[this.activeType].getActive() : false;
    },
    setActive: function (active) {
        const type = optionsForm.elements['draw-type'].value;

        if (active) {
            this.activeType && this[this.activeType].setActive(false);
            this[type].setActive(true);
            this.activeType = type;
        } else {
            this.activeType && this[this.activeType].setActive(false);
            this.activeType = null;

        }
    },
};
ExampleDraw.init();

/**
 * Let user change the geometry type.
 * @param {Event} e Change event.
 */
optionsForm.onchange = function (e) {
    const type = e.target.getAttribute('name');
    const value = e.target.value;
    if (value !== 'none') {
        if (type == 'draw-type') {
            ExampleDraw.getActive() && ExampleDraw.setActive(true);
        } else if (type == 'interaction') {
            if (value == 'modify') {
                ExampleDraw.setActive(false);
                ExampleModify.setActive(true);
            } else if (value == 'draw') {
                ExampleDraw.setActive(true);
                ExampleModify.setActive(false);
            }
        }
    }
};

ExampleDraw.setActive(false);
ExampleModify.setActive(false);

// The snap interaction must be added after the Modify and Draw interactions
// in order for its map browser event handlers to be fired first. Its handlers
// are responsible of doing the snapping.
const snap = new Snap({
    source: Drawvector.getSource(),
});

drawPoint.on('drawend', function(evt){
    evt.feature.set('group','drawing');
    drawFeatures.push(evt.feature.ol_uid);
    $('.gseda_side_panel_left').addClass('active');
    setDrawFeatureObjectHtml(evt.feature);
});
drawLineString.on('drawend', function(evt){
    evt.feature.set('group','drawing');
    drawFeatures.push(evt.feature.ol_uid);
    $('.gseda_side_panel_left').addClass('active');
    setDrawFeatureObjectHtml(evt.feature);
});
drawPolygon.on('drawend', function(evt){
    evt.feature.set('group','drawing');
    drawFeatures.push(evt.feature.ol_uid);
    $('.gseda_side_panel_left').addClass('active');
    setDrawFeatureObjectHtml(evt.feature);
});
drawCircle.on('drawend', function(evt){
    evt.feature.set('group','drawing');
    drawFeatures.push(evt.feature.ol_uid);
    $('.gseda_side_panel_left').addClass('active');
    setDrawFeatureObjectHtml(evt.feature);
});
map.addInteraction(snap);


document.getElementById('undo').addEventListener('click', function () {
    draw.removeLastPoint();
});

addInteraction();


// پایان کد ترسیم خط_نقطه_پولیگون و ویرایش آنها

//کدهای مربوط به دکمه های فعالسازی ابزار
var acc = document.getElementsByClassName("btn_goto");
var inew;

for (inew = 0; inew < acc.length; inew++) {
    acc[inew].onclick = function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    }
}


var acc = document.getElementsByClassName("btn_Layer");
var inew;

for (inew = 0; inew < acc.length; inew++) {
    acc[inew].onclick = function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    }
}


var acc = document.getElementsByClassName("btn_exporter");
var inew;

for (inew = 0; inew < acc.length; inew++) {
    acc[inew].onclick = function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    }
}


var acc = document.getElementsByClassName("btn_Draw");
var inew;

for (inew = 0; inew < acc.length; inew++) {
    acc[inew].onclick = function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    }
}


var acc = document.getElementsByClassName("btn_Measure");
var inew;

for (inew = 0; inew < acc.length; inew++) {
    acc[inew].onclick = function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    }
}


var acc = document.getElementsByClassName("btn_Sea");
var inew;

for (inew = 0; inew < acc.length; inew++) {
    acc[inew].onclick = function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    }
}


//کدهای مربوط به دکمه های فعالسازی ابزار


//شروع کد گرفتن اطلاعات از wms

map.on('singleclick', function (evt) {
    if (!$('#getinfo_status').is(':checked')) {
        return;
    }
    document.getElementById('info').innerHTML = '';
    const viewResolution = map.getView().getResolution();

    const url = shahrestanwmsSource.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        'EPSG:3857',
        {'INFO_FORMAT': 'text/html', 'propertyName': 'استان,شهرست,مرکز,زون,مساحت'}
    );
    if (url) {
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                document.getElementById('info').innerHTML = html;
            });
    }
});

map.on('pointermove', function (evt) {
    if (evt.dragging) {
        return;
    }
    const pixel = map.getEventPixel(evt.originalEvent);
    const hit = map.forEachLayerAtPixel(pixel, function () {
        return true;
    });
    map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});

// پایان کد گرفتن اطلاعات از wms


///////////// menu ////////////////
var pinIcon = 'https://cdn.jsdelivr.net/gh/jonataswalker/ol-contextmenu@604befc46d737d814505b5d90fc171932f747043/examples/img/pin_drop.png';
var centerIcon = 'https://cdn.jsdelivr.net/gh/jonataswalker/ol-contextmenu@604befc46d737d814505b5d90fc171932f747043/examples/img/center.png';
var listIcon = 'https://cdn.jsdelivr.net/gh/jonataswalker/ol-contextmenu@604befc46d737d814505b5d90fc171932f747043/examples/img/view_list.png';

var contextmenuItems = [
    {
        text: 'Center map here',
        classname: 'bold',
        icon: centerIcon,
        callback: center
    },
    {
        text: 'Some Actions',
        icon: listIcon,
        items: [
            {
                text: 'Center map here',
                icon: centerIcon,
                callback: center
            },
            {
                text: 'Add a Marker',
                icon: pinIcon,
                callback: marker
            }
        ]
    },
    {
        text: 'Add a Marker',
        icon: pinIcon,
        callback: marker
    },
    '-' // this is a separator
];

var contextmenu = new ContextMenu({
    width: 180,
    items: contextmenuItems
});
map.addControl(contextmenu);

var removeMarkerItem = {
    text: 'Remove this Marker',
    classname: 'marker',
    callback: removeMarker
};

contextmenu.on('open', function (evt) {
    var feature =	map.forEachFeatureAtPixel(evt.pixel, ft => ft);

    if (feature && feature.get('type') === 'removable') {
        contextmenu.clear();
        removeMarkerItem.data = { marker: feature };
        contextmenu.push(removeMarkerItem);
    } else {
        contextmenu.clear();
        contextmenu.extend(contextmenuItems);
        contextmenu.extend(contextmenu.getDefaultItems());
    }
});

map.on('pointermove', function (e) {
    if (e.dragging) return;

    var pixel = map.getEventPixel(e.originalEvent);
    var hit = map.hasFeatureAtPixel(pixel);

    map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});

// from https://github.com/DmitryBaranovskiy/raphael
function elastic(t) {
    return Math.pow(2, -10 * t) * Math.sin((t - 0.075) * (2 * Math.PI) / 0.3) + 1;
}

function center(obj) {
    mainView.animate({
        duration: 700,
        easing: elastic,
        center: obj.coordinate
    });
}

function removeMarker(obj) {
    vectorLayerMenu.getSource().removeFeature(obj.data.marker);
}

function marker(obj) {
    var coord4326 = transform(obj.coordinate, 'EPSG:3857', 'EPSG:4326'),
        template = 'Coordinate is ({x} | {y})',
        iconStyle = new Style({
            image: new Icon({ scale: .6, src: pinIcon }),
            text: new Text({
                offsetY: 25,
                text: format(coord4326, template, 2),
                font: '15px Open Sans,sans-serif',
                fill: new Fill({ color: '#111' }),
                stroke: new Stroke({ color: '#eee', width: 2 })
            })
        }),
        feature = new Feature({
            type: 'removable',
            geometry: new Point(obj.coordinate)
        });

    feature.setStyle(iconStyle);
    vectorLayerMenu.getSource().addFeature(feature);
}
//////////////////// menu////////



//////////////// click on icon ////////////
$(document).on("click", ".rmbs_control_measurement_tools_polygon:not(.active), .rmbs_control_measurement_tools_line:not(.active), .rmbs_control_measurement_tools_clear", function(e) {

    var o = $(this);
    console.log(o);
    var t = o.attr("rev");
    $(".rmbs_control_measurement_tools_polygon, .rmbs_control_measurement_tools_line, .rmbs_control_measurement_tools_clear").removeClass("active");
    if ("clear" != t) {
        o.addClass("active");
    }
    if(t=='line'){
        $('#type').val('length').trigger('change');
        $('.rmbs_control_measurement_tools_line').addClass("active");
    }else if(t=='polygon'){
        $('#type').val('area').trigger('change');
        $('.rmbs_control_measurement_tools_polygon').addClass("active");
    }else{
        source.clear();
        measureTooltips.forEach(function (mt){
            map.removeOverlay(mt);
        });
        $('#type').val('none').trigger('change');
    }

    //todo: start
})
$(document).on("click", ".rmbs_control_measurement_tools_switch", function(){
    var o=$(this);
    if(o.hasClass("active")) {
        o.removeClass("active");
        o.find(".active:not(.rmbs_control_measurement_tools_geodesic)").removeClass("active");
        $('.rmbs_control_measurement_tools').removeClass("active")
        $('#type').val('none').trigger('change');
        //TODO: close

    }else {
        $(".rmbs_control_measurement_tools_polygon, .rmbs_control_measurement_tools_line, .rmbs_control_measurement_tools_clear").removeClass("active");
        o.addClass("active");
        $('.rmbs_control_measurement_tools_line').addClass("active");
        o.find(".rmbs_control_measurement_tools_inner").first().trigger("click");
        $('.rmbs_control_measurement_tools').addClass("active");
        $('#type').val('length').trigger('change');
        //TODO: start
    }
})


$(document).on("click", ".rmbs_control_draw_tools_inner:not(.active), .rmbs_control_draw_tools_clear", function(e) {

    var o = $(this);
    console.log(o);
    var rev = o.attr("rev");
    var revl = rev.toLowerCase();
    $(".rmbs_control_draw_tools_inner").removeClass("active");
    if (!(rev == 'clear' || rev == 'undo')) {
        o.addClass("active");
    }
    if (rev == 'clear') {
        DrawSource.clear();
        $('#draw-type').val('none').trigger('change');
    }else if(rev == 'undo'){
        console.log(drawFeatures);
        let dfc=drawFeatures.length;
        let last_feature_id=drawFeatures.pop();
        var Drawvector_features = Drawvector.getSource().getFeatures();
        Drawvector_features.forEach(function(source_feature) {
            var source_feature_id = source_feature.ol_uid;
            if (source_feature_id === last_feature_id) {
                Drawvector.getSource().removeFeature(source_feature);
            }
        });
        $('#draw-type').val('none').trigger('change');
    }else{
        $('#draw-type').val(rev).trigger('change');
        $('.rmbs_control_draw_tools_'+revl).addClass("active");
    }

    //todo: start
})
$(document).on("click", ".rmbs_control_draw_tools_switch", function(){
    var o=$(this);
    if(o.hasClass("active")) {
        o.removeClass("active");
        $('.rmbs_control_draw_tools').removeClass("active")
        $('#draw-type').val('none').trigger('change');
        ExampleDraw.setActive(false);
        //TODO: close

    }else {
        $(".rmbs_control_draw_tools_inner").removeClass("active");
        o.addClass("active");
        $('.rmbs_control_draw_tools_line').addClass("active");
        o.find(".rmbs_control_draw_tools_inner").first().trigger("click");
        $('.rmbs_control_draw_tools').addClass("active");
        $('#draw-type').val('length').trigger('change');
        //TODO: start
    }
})


function removeLayerByName(name){
    map.getLayers().forEach(function (layer) {
        if (layer.get('name') != undefined && layer.get('name') === name) {
            map.removeLayer(layer);
        }
    });
}
//////////////// end click on icons //////////

function setDrawFeatureObjectHtml(feature,obj={},others={}) {
    let ol_uid=feature.ol_uid;
    var el=getDrawFeatureObject(feature);
    console.log('mm')
    console.log(el);
    console.log('nn')

    $('#featureProps').attr('data-id',ol_uid);
    $('.gseda_side_panel_title_text').html('<input type="text" placeholder="نام" id="featureName" value="' + el.name + '">');
    console.log('tt');
    console.log(el.props);
    console.log('bb');
    if($.isEmptyObject(el.props)) {
        $('#featureProps tbody').html('<tr><td><input type="text" placeholder="شخصه" class="featureProp">' +
            '</td><td><input type="text" placeholder="مقدار" class="featureVal"></td><td><i class="fa fa-minus featurePropsDel"></i></td></tr>');
    }else{
        $('#featureProps tbody').html('');
        Object.keys(el.props).forEach(function(key) {
            $('#featureProps tbody').append('<tr><td><input type="text" placeholder="شخصه" class="featureProp" value="'+Base64.decode(key)+'">' +
                '</td><td><input type="text" placeholder="مقدار" class="featureVal"  value="'+el.props[key]+'"></td><td><i class="fa fa-minus featurePropsDel"></i></td></tr>');
        })
    }

}
function setDrawFeatureObject(ol_uid,obj={},others={}){
    if(drawFeatureObjects[ol_uid]===undefined){
        drawFeatureObjects[ol_uid]={
            name: (obj.name===undefined ? '' : obj.name),
            type: (obj.type===undefined ? '' : obj.type),
            data: (obj.data===undefined ? '' : obj.data),
        }
        return drawFeatureObjects[ol_uid];
    }else{
        if(obj.name!==undefined) {
            drawFeatureObjects[ol_uid].name = obj.name;
        }
        if(obj.type!==undefined) {
            drawFeatureObjects[ol_uid].name = obj.type;
        }
        if(obj.data!==undefined) {
            drawFeatureObjects[ol_uid].name = obj.data;
        }
        let features=Drawvector.getSource().getFeatures();
        features.forEach(function (f){
            if(f.ol_uid==ol_uid){
                let m= new GeoJSON;
                 obj.data=m.writeFeature(f)
            }
        })
        console.log('5555');
        console.log(obj.data);
        //Object.keys(others).forEach(function(key) {
            drawFeatureObjects[ol_uid].props=others;
        //});
        console.log(drawFeatureObjects[ol_uid]);
        return drawFeatureObjects[ol_uid];
    }
}
function getDrawFeatureObject(feature,obj={}){
    let ol_uid=feature.ol_uid;
    if(drawFeatureObjects[ol_uid]===undefined){
        drawFeatureObjects[ol_uid]={
            name: (obj.name===undefined ? '' : obj.name),
            type: (obj.type===undefined ? '' : obj.type),
            data: (obj.data===undefined ? '' : obj.data),
            feature: feature,
        }
        return drawFeatureObjects[ol_uid];
    }else{
        return drawFeatureObjects[ol_uid];
    }
}
map.on('singleclick', function (e) {
    let hit = false;
    $('.gseda_side_panel_left').removeClass('active');
    map.forEachFeatureAtPixel(
        e.pixel,
        function (feature, layer) {
            console.log(feature);
            ExampleModify.setActive(true);
            $('.gseda_side_panel_left').addClass('active');
            setDrawFeatureObjectHtml(feature);

        }
    );
});

$(document).ready(function (){
    $("body").on('click','.featurePropsAdd',function () {
        $('#featureProps tbody').append('<tr><td><input type="text" placeholder="شخصه" class="featureProp">' +
            '</td><td><input type="text" placeholder="مقدار" class="featureVal"></td><td><i class="fa fa-minus featurePropsDel"></i></td></tr>');
    });
    $("body").on('click','.featurePropsDel',function () {
        $(this).parent().parent().remove();
    });
    $("body").on('click','#saveFeature',function () {
        console.log('rrr');
        let ol_uid=$('#featureProps').attr('data-id');
        console.log(ol_uid);
        let name=$('#featureName').val();
        let body=$('#featureProps tbody');
        let fprops={};
        $(body).find('tr').each(function(){
            let p=$(this).find('.featureProp').val();
            if(p!='') {
                p=Base64.encode(p);
                let v=$(this).find('.featureVal').val();
                fprops[p]=v;
            }
        });
        setDrawFeatureObject(ol_uid,{name: name},fprops);
    });
    $(".rmbs_side_panel_title_close").click(function () {
        $('.gseda_side_panel_left').removeClass('active')
    });
});

